<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="纳税人姓名" prop="userName">
                <Input
                  v-model="query.userName"
                  clearable
                  placeholder="请输入纳税人姓名"
                  maxlength="10"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="纳税人识别码/身份证号" prop="idCardNO">
                <Input
                  v-model="query.idCardNO"
                  clearable
                  placeholder="请输入纳税人识别码/身份证号"
                  maxlength="18"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="契税号" prop="taxNO">
                <Input
                  v-model="query.taxNO"
                  clearable
                  placeholder="请输入契税号"
                  maxlength="18"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="查询时间段" prop="time">
                <DatePicker
                  v-model="time"
                  class="time"
                  type="daterange"
                  placeholder="请选择查询时间段"
                ></DatePicker>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
    </div>
    <div class="content" v-if="info.nsrmc">
      <div class="search">
        <Form>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="纳税人姓名">
                <div class="detail">{{info.nsrmc}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="纳税人识别码/身份证号">
                <div class="detail">{{info.nsrsbh}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="契税号">
                <div class="detail">{{info.dzsphm}}</div>
              </FormItem>
            </i-col>
            <i-col span="24">
              <FormItem label="备注">
                <div class="detail">{{info.bz}}</div>
              </FormItem>
            </i-col>
          </row>
        </Form>
      </div>
    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { taxQuery } = api;
export default {
  name: "taxQuery",
  components: {
    pageHead,
  },

  data() {
    return {
      query: {
        userName: "",
        idCardNO: "",
        taxNO: "",
        beginTime: "",
        endTime: "",
      },
      info: {},
      time: [],
      title: "契税信息查询",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "查询",
          type: "search",
        },
      ],
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.query.userName = "";
        this.query.idCardNO = "";
        this.query.taxNO = "";
        this.query.userName = "";

        this.query.beginTime = "";
        this.query.endTime = "";
        this.time = [this.beginTime, this.endTime];
        this.$refs.search.resetFields();
      } else if (type == "search") {
        this.taxQuery();
      }
    },
    async taxQuery() {
      if (!this.query.userName) {
        return this.$Message.warning("请输入纳税人姓名");
      }
      if (!this.query.idCardNO) {
        return this.$Message.warning("请输入纳税人识别码/身份证号");
      }
      if (!this.query.taxNO) {
        return this.$Message.warning("请输入契税号");
      }
      if (this.time.length == 0) {
        return this.$Message.warning("请选择查询时间段");
      }
      if (this.time[0]) {
        this.query.beginTime = this.$util.FormatDate(
          this.time[0],
          "yyyy-MM-dd"
        );
        this.query.endTime = this.$util.FormatDate(this.time[1], "yyyy-MM-dd");
      }
      try {
        let data = {
          nsrsbh: this.query.idCardNO,
          nsrmc: this.query.userName,
          dzsphm: this.query.taxNO,
          ksrq: this.query.beginTime,
          jsrp: this.query.endTime,
        };
        console.log(data);
        let res = await this.$post(taxQuery, data);
        // this.$Message.success("开票成功");
        console.log(res);
        if(res.isSucceed) {
          let data = res.rows && res.rows[0]
          this.info = data;
        }
      } finally {
      }
      console.log(this.query);
    },
    initDate() {
      this.beginTime = this.$util.FormatDate(
        new Date(new Date() - 31536000000),
        "yyyy-MM-dd"
      );
      this.endTime = this.$util.FormatDate(new Date(), "yyyy-MM-dd");
      console.log(this.beginTime, this.endTime);
      this.time = [this.beginTime, this.endTime];
    },
  },
  created() {
    this.initDate();
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}
.time {
  width: 100%;
}
</style>